import { Injectable } from '@angular/core';
import { Http, Response , Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { Router} from '@angular/router';

@Injectable()
export class InterviewdetailService {

  constructor(private http: Http,private router: Router) { }




      
success: string;
   
 result:Array<Object>; 

 getUserData()
    {
 
   
    const headers=new Headers({'Content-Type': 'application/json'});
     return this.http.get('http://gunadhyasoft.com/girswebservices/getdata.php')
      .map(
    (response: Response)=>response.json()
     
    ) 
    }
  


        fetchData_Byid(selectedid:number)
      {


       console.log(" In service id New " +selectedid);

       // const headers=new Headers({'Content-Type': 'application/json'});
       return this.http.get('http://gunadhyasoft.com/girswebservices/getData_byId.php?id='+selectedid+'')
       .map(
    (response: Response)=>
      {
      console.log("In interviewdetail by id result" +response.json());
       this.success=response.json();
    if(response.json() == "Success")
    {
      console.log("In success");

        this.router.navigate(['interviewrating']);
        return true;
    }

    }
    ) 
  
   

}

 selectedid()
{


}





}


// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/interviewdetail/interviewdetail.service.ts